import dayjs from 'dayjs'

import { Tooltip } from 'antd'
import { FilterFilled } from '@ant-design/icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClinicMedical, faHouse, faVideoCamera } from '@fortawesome/free-solid-svg-icons'
import { generateStatus } from '../../../lib/booking-utils'

const templates = {
  columnTemplate: (
    token,
    bookings,
    isSinglePatient,
    cancelBooking,
    authState,
    filteredValues,
    handleReassignment,
    rangeFilter,
    handleSetPaymentMethod,
    services,
    setTeamChatProps,
    handleViewRecord,
    isBilling
  ) => {
    return [
      {
        title: <h2>Patient</h2>,
        hidden: isSinglePatient,
        dataIndex: 'patientName',
        key: 'patientName',
        render: (text) => {
          if (text) {
            return text
          } else {
            return <span style={{ color: token.colorError }}>Patient Not Found</span>
          }
        },
        sorter: (a, b) => {
          return a.patientName.localeCompare(b.patientName)
        }
      },
      {
        hidden: authState.agiliteUser?.extraData.role.type !== 'reception' || isBilling,
        title: <h2>OTP</h2>,
        dataIndex: 'otp',
        key: 'otp'
      },
      {
        title: <h2>Clinic</h2>,
        dataIndex: 'clinicName',
        key: 'clinicName',
        hidden:
          authState.agiliteUser?.extraData.role.type === 'reception' ||
          authState.agiliteUser?.extraData.role.type === 'medical_professional',
        render: (text) => {
          if (text) {
            return text
          } else {
            return <span style={{ color: token.colorError }}>Clinic Not Found</span>
          }
        },
        // filters: uniqBy(
        //   bookings.map((booking) => {
        //     return { text: booking.clinicName, value: booking.clinicName }
        //   }),
        //   'text'
        // ),
        // onFilter: (value, record) => {
        //   return record.clinicName.indexOf(value) === 0
        // },
        filterIcon: (
          <Tooltip title='Filter by Clinic Name'>
            <FilterFilled />
          </Tooltip>
        )
      },
      {
        title: <h2>Medical Professional</h2>,
        dataIndex: 'professionalName',
        key: 'professionalName',
        hidden:
          authState.agiliteUser?.extraData.role.type === 'medical_professional' &&
          authState.agiliteUser?.extraData.profession === 'doctor',
        render: (text) => {
          if (text) {
            return text
          } else {
            return <span style={{ color: token.colorError }}>Medical Professional Not Found</span>
          }
        },
        // filters: uniqBy(
        //   bookings.map((booking) => {
        //     return { text: booking.professionalName, value: booking.professionalName }
        //   }),
        //   'text'
        // ),
        // filteredValue: filteredValues?.professionalName,
        // onFilter: (value, record) => {
        //   return record.professionalName.indexOf(value) === 0
        // },
        filterIcon: (
          <Tooltip title='Filter by Medical Professional'>
            <FilterFilled />
          </Tooltip>
        )
      },
      {
        title: 'Reason for Visit',
        render: (record) => {
          return record.chiefComplaint
        }
      },
      {
        title: 'Main Member',
        render: (record) => {
          if (record.patientRecord?.mainMemberId) {
            return 'No'
          } else {
            return 'Yes'
          }
        }
      },
      {
        title: <h2>Profession</h2>,
        dataIndex: 'profession',
        key: 'profession',
        hidden:
          isSinglePatient ||
          authState.agiliteUser?.extraData.role.type === 'reception' ||
          (authState.agiliteUser?.extraData.role.type === 'medical_professional' &&
            authState.agiliteUser?.extraData.profession === 'doctor')
        // filters: uniqBy(
        //   bookings.map((booking) => {
        //     return { text: booking.profession, value: booking.profession }
        //   }),
        //   'text'
        // ),
        // onFilter: (value, record) => {
        //   return record.profession.indexOf(value) === 0
        // },
        // filterIcon: (
        //   <Tooltip title='Filter by Profession'>
        //     <FilterFilled />
        //   </Tooltip>
        // )
      },
      {
        title: <h2>Date</h2>,
        dataIndex: 'bookingDate',
        key: 'bookingDate',
        hidden: rangeFilter === 'today',
        render: (text) => {
          return dayjs(text).format('YYYY-MM-DD')
        },
        sorter: (a, b) => {
          return dayjs(a.bookingDate).format('YYYY-MM-DD') > dayjs(b.bookingDate).format('YYYY-MM-DD')
        }
      },
      {
        title: <h2>Time</h2>,
        dataIndex: 'startTime',
        key: 'bookingTime',
        sorter: (a, b) => {
          return a.startTime > b.startTime
        }
      },
      {
        title: <h2>Type</h2>,
        hidden: false,
        key: 'isVirtualVisit',
        render: (text, record) => {
          if (record.isVirtualVisit) {
            return (
              <>
                Virtual <FontAwesomeIcon icon={faVideoCamera} color={token.colorWarning} />
              </>
            )
          } else if (record.clinicRef === 'Home Visit') {
            return (
              <>
                Home Visit <FontAwesomeIcon icon={faHouse} color={token.colorPrimary} />
              </>
            )
          } else {
            return (
              <>
                Clinic <FontAwesomeIcon icon={faClinicMedical} color={token.colorSecondary} />
              </>
            )
          }
        },
        responsive: ['sm']
      },
      {
        title: <h2>Status</h2>,
        dataIndex: 'status',
        hidden: isBilling,
        key: 'status',
        render: (text, record) => {
          console.log(record.status)
          return generateStatus(record, record?.status, token, record?.wasNoShow)
        }
      },
      // {
      //   title: <h2>Service</h2>,
      //   key: 'service',
      //   render: (text, record) => {
      //     return <>{record.serviceRecord?.name}</>
      //   }
      // },
      {
        title: <h2>Payment</h2>,
        dataIndex: 'paymentMethod',
        key: 'paymentMethod',
        hidden: authState.agiliteUser?.extraData.role.type !== 'reception',
        responsive: ['sm']
      }
    ]
  }
}

export default templates
